import {footer} from "./src/Footer";
import {header} from "./src/Header";
import {toggle} from "./src/Toggle";

(function (Drupal) { // closure
    'use strict';
    Drupal.behaviors.footer = footer;
    Drupal.behaviors.header = header;
    Drupal.behaviors.toggle = toggle;
}(Drupal));
